var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.681,
    height: 37.441,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{fill:#8a8a8a}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "android"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    d: "M44.861 179.141a2.235 2.235 0 0 0-1.642.675 2.209 2.209 0 0 0-.675 1.62v9.675a2.3 2.3 0 0 0 2.317 2.318 2.2 2.2 0 0 0 1.632-.675 2.256 2.256 0 0 0 .664-1.643v-9.675a2.3 2.3 0 0 0-2.3-2.295z",
    className: "cls-1",
    "data-name": "Path 27",
    transform: "translate(-42.544 -167.013)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    d: "M138.176 3.442L139.773.5a.3.3 0 0 0-.112-.45.312.312 0 0 0-.45.135l-1.62 2.971a11.286 11.286 0 0 0-9.045 0L126.926.18a.312.312 0 0 0-.45-.135.3.3 0 0 0-.112.45l1.6 2.947a9.865 9.865 0 0 0-3.87 3.454 8.724 8.724 0 0 0-1.44 4.849h20.812a8.726 8.726 0 0 0-1.44-4.849 9.907 9.907 0 0 0-3.85-3.454zm-9.236 4.287a.843.843 0 0 1-.619.259.805.805 0 0 1-.607-.259.9.9 0 0 1 0-1.237.808.808 0 0 1 .607-.259.875.875 0 0 1 .619 1.5zm9.484 0a.807.807 0 0 1-.607.259.878.878 0 0 1 0-1.755.809.809 0 0 1 .607.259.9.9 0 0 1 0 1.237z",
    className: "cls-1",
    "data-name": "Path 28",
    transform: "translate(-117.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    d: "M123.971 200.435a2.457 2.457 0 0 0 2.475 2.475h1.665l.023 5.108a2.236 2.236 0 0 0 .675 1.643 2.21 2.21 0 0 0 1.62.675 2.3 2.3 0 0 0 2.317-2.318v-5.108h3.1v5.108a2.317 2.317 0 1 0 4.635 0v-5.108h1.688a2.457 2.457 0 0 0 2.452-2.475V185.45h-20.65z",
    className: "cls-1",
    "data-name": "Path 29",
    transform: "translate(-118.458 -172.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M444.671 179.141a2.23 2.23 0 0 0-1.62.664 2.2 2.2 0 0 0-.675 1.631v9.675a2.235 2.235 0 0 0 .675 1.643 2.21 2.21 0 0 0 1.62.675 2.3 2.3 0 0 0 2.317-2.318v-9.675a2.2 2.2 0 0 0-.675-1.631 2.257 2.257 0 0 0-1.642-.664z",
    className: "cls-1",
    "data-name": "Path 30",
    transform: "translate(-415.308 -167.013)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.d577e7702613153e5894f2031acc0d3f.svg";
export { ForwardRef as ReactComponent };